import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "username text-h6 font-weight-bold" }
const _hoisted_2 = { class: "user-actions d-flex" }

import type { AppNavigationItem } from './AppNavigationItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNavigation',
  setup(__props) {


const user = useUserStore()
const ui = useUiStore()
const routes: AppNavigationItem[] = [
  ui.navigationItems.home,
  ui.navigationItems.insights,
  ui.navigationItems.startups,
  ui.navigationItems.investors,
  ui.navigationItems.investorsScout,
  ui.navigationItems.sosvUniversity,
  ui.navigationItems.wiki,
  {
    title: 'My Tools',
    children: [
      ui.navigationItems.onboarding,
      ui.navigationItems.news,
      ui.navigationItems.programs,
      ui.navigationItems.forms,
      ui.navigationItems.people,
      ui.navigationItems.chatbots,
      ui.navigationItems.logs,
      ui.navigationItems.sosvCentral
    ]
  }
]

function handleUpdateProfile() {
  ui.clearNavigation()
  navigateTo({ name: 'contact-edit', params: { slug: user.contact.slug } })
}

async function handleLogout() {
  await user.logout()
  navigateTo({ name: 'login', query: { logout: 'true' } })
  Notify.info('You have been logged out.')
}


return (_ctx: any,_cache: any) => {
  const _component_AppMobileNavigator = _resolveComponent("AppMobileNavigator")!
  const _component_AppNavigationItem = _resolveComponent("AppNavigationItem")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_ctx.$ui.desktop || _ctx.$ui.navigation.status)
    ? (_openBlock(), _createBlock(_component_v_sheet, {
        key: 0,
        color: "transparent",
        "min-width": "270",
        height: "90vh",
        width: _ctx.$ui.mobile ? '100%' : undefined,
        class: "hy-navigation d-flex flex-column justify-space-between align-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            width: "270",
            "bg-color": "transparent",
            color: "#FFFFFFFF",
            "base-color": "#FFFFFFAA",
            density: "compact",
            flat: "",
            tile: "",
            nav: "",
            class: _normalizeClass({ 'position-fixed': _ctx.$ui.desktop })
          }, {
            default: _withCtx(() => [
              (_ctx.$ui.mobile)
                ? (_openBlock(), _createBlock(_component_AppMobileNavigator, { key: 0 }))
                : _createCommentVNode("", true),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routes, (route) => {
                return _createVNode(_component_AppNavigationItem, _mergeProps({
                  key: route.title
                }, { ref_for: true }, route), null, 16)
              }), 64))
            ]),
            _: 1
          }, 8, ["class"]),
          (_ctx.$ui.mobile)
            ? (_openBlock(), _createBlock(_component_v_list, {
                key: 0,
                width: "250",
                "bg-color": "#295fd2AA",
                color: "#FFFFFFFF",
                "base-color": "#FFFFFFAA",
                density: "compact",
                rounded: "",
                flat: "",
                nav: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    "prepend-avatar": _unref(user).avatar,
                    rounded: "0",
                    class: "hy-mobile-user"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(user).name), 1),
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                          class: "update-profile",
                          onClick: handleUpdateProfile
                        }, [
                          _createVNode(_component_hy_icon, {
                            name: "Edit",
                            tiny: ""
                          }),
                          _cache[0] || (_cache[0] = _createTextVNode(" update ", -1))
                        ]),
                        _createVNode(_component_v_divider, {
                          color: "white",
                          thickness: "2",
                          vertical: "",
                          class: "mx-2"
                        }),
                        _createElementVNode("div", {
                          class: "logout",
                          onClick: handleLogout
                        }, [
                          _createVNode(_component_hy_icon, {
                            name: "Logout",
                            tiny: ""
                          }),
                          _cache[1] || (_cache[1] = _createTextVNode(" logout ", -1))
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["prepend-avatar"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["width"]))
    : _createCommentVNode("", true)
}
}

})